import { render, staticRenderFns } from "./TixianResult.vue?vue&type=template&id=6b2707ab&"
import script from "./TixianResult.vue?vue&type=script&lang=js&"
export * from "./TixianResult.vue?vue&type=script&lang=js&"
import style0 from "./TixianResult.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports